<template>
    <q-table
        ref="table"
        :data="data"
        :columns="columns"
        row-key="id"
        :pagination.sync="server_pagination"
        @request="request"
        :loading="loading"
        :no-data-label="$t('no_data_avaliable')"
        :no-results-label="$t('no_results_found')"
        :loading-label="$t('loading_data')"
        :rows-per-page-label="$t('items_per_page')"
        :rows-per-page-options="[5,10,50,100]"
        binary-state-sort
        class="q-mt-lg"
        >

        <q-tr slot="header" slot-scope="props" :props="props">
            <q-th v-for="col in props.cols" :key="col.name" :props="props">
            {{ $t(col.label) }}
            </q-th>
        </q-tr>

        <template slot="body" slot-scope="props">
            <q-tr :props="props">
                <q-td key="id" :props="props">
                    {{ props.row.id }}
                </q-td>

                <q-td key="title" :props="props">
                    {{ props.row.title }}
                </q-td>

                <q-td key="subscribe_date" :props="props">
                    {{ getDateFormated(props.row.subscribe_date) }}
                </q-td>

                <q-td key="qty_trail_contents" :props="props">
                    {{ props.row.qty_trail_contents }}
                </q-td>


                <q-td key="qty_content_user_approved" :props="props">
                    {{ $t(props.row.qty_content_user_approved) }}
                </q-td>

                <q-td key="user_progress" :props="props">
                    {{ props.row.user_progress }}%
                </q-td>

                <q-td key="is_mandatory" :props="props">
                    {{ $t(getMandatory(props.row.is_mandatory)) }}
                </q-td>

                <q-td key="status" :props="props">
                    {{ $t(getStatus(props.row.status)) }}
                </q-td>
            </q-tr>
        </template>
    </q-table>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
const { formatDate } = date

export default {
    data() {
        return {
            loading: false,
            server_pagination: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: null,
                descending: false,
                sortBy: null
            },
            columns: [
                {
                    name: 'id',
                    required: true,
                    label: '#',
                    align: 'id',
                    field: 'title',
                    sortable: false,
                },
                {
                    name: 'title',
                    required: true,
                    label: 'title',
                    align: 'left',
                    field: 'title',
                    sortable: false,
                },
                {
                    name: 'subscribe_date',
                    required: true,
                    label: 'enrollment_date',
                    align: 'left',
                    field: 'subscribe_date',
                    sortable: false,
                },
                {
                    name: 'qty_trail_contents',
                    required: true,
                    label: 'number_of_activities',
                    align: 'left',
                    field: 'qty_trail_contents',
                    sortable: false,
                },
                {
                    name: 'qty_content_user_approved',
                    required: true,
                    label: 'completed_activities',
                    align: 'left',
                    field: 'qty_content_user_approved',
                    sortable: false,
                },
                {
                    name: 'user_progress',
                    required: true,
                    label: 'progress',
                    align: 'left',
                    field: 'user_progress',
                    sortable: false,
                },
                {
                    name: 'is_mandatory',
                    required: true,
                    label: 'type',
                    align: 'left',
                    field: 'is_mandatory',
                    sortable: false,
                },
                {
                    name: 'status',
                    required: true,
                    label: 'status',
                    align: 'left',
                    field: 'status',
                    sortable: false,
                }
            ],
            data: []
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            selected_user: 'users/selected_user',
            num_rows: 'datatable/num_rows'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },
    },

    methods: {
        request({ pagination }) {
            this.loading = true
            this.server_pagination = pagination

            let order = pagination.descending ? '-' : ''
            let order_by = pagination.sortBy ? order + pagination.sortBy : ''

            let data = {
                "page_size": this.server_pagination.rowsPerPage,
                "page": this.server_pagination.page,
                "ordering": order_by
            }

            this.savePagination()

            this.$axios.get(`/admin_users/users/${this.selected_user}/get_user_trail_subscriptions/?${this.$qs.stringify(data)}`, this.getHeader)
            .then(response => {
                this.server_pagination.rowsNumber = response.data.count
                this.data = []

                response.data.results.forEach(result => {
                    this.data.push(result)
                })

                this.loading = false
            })
            .catch(e => {
                this.loading = false
                console.log(e)
            })
        },

        getStatus(status) {
            if(status == 1) return 'aproved'
            if(status == 2) return 'reproved'
            if(status == 3) return 'missed'
            if(status == 4)  return 'in_progress'
            if(status == null) return 'pending'
        },

        getMandatory(isMandatory) {
            if (isMandatory == null || isMandatory == false) {
                return 'optional'
            } else {
                return 'mandatory'
            }
        },

        getDateFormated(d) {
            return date.formatDate(d, 'DD/MM/YYYY HH:mm:ss')
        },

        savePagination() {
            this.$store.dispatch('datatable/SET_NUM_ROWS', [this.server_pagination.rowsPerPage])
        },

        loadPagination() {
            this.server_pagination.rowsPerPage = this.num_rows
        }
    },

    watch: {
        num_rows: {
            handler (newValue) {
                this.loadPagination()
            },
            deep: true
        }
    },

    created() {
        this.loadPagination()

        this.request({ pagination: this.server_pagination })
    }
}
</script>

<style>

</style>
